import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import * as GuestService from 'services/guest';

const AccountActivation = () => {
  const { tenant_id, user_id } = useParams();
  const history = useHistory();

  const [is_accepting, setIsAccepting] = useState(true);
  const [activation_status, setActivationStatus] = useState(false);

  useEffect(() => {
    setIsAccepting(true);
    GuestService.acceptance(tenant_id, user_id).then((response) => {
      setIsAccepting(false);
      const { error } = response;
      if (error) {
        setActivationStatus(false);
        return;
      }

      //
      setActivationStatus(true);
    });
  }, [tenant_id, user_id]);

  const displayActivationResult = () => {
    if (activation_status) {
      return (
        <div>
          Invitation accepted.
          <span
            className="gm-text-primary float-none pl-2 is-clickable"
            onClick={() => history.push('/login')}
          >
            <b className="float-none">Log In.</b>
          </span>
        </div>
      );
    }

    return <div>Could not accept Invitation. Please try again later.</div>;
  };

  return (
    <div>
      <div className="form-wrapper flex-col-center">
        <div className="py-3 text-center text-blue-4">
          {is_accepting ? (
            <div> Validating your invitation. Please wait... </div>
          ) : (
            displayActivationResult()
          )}
        </div>
      </div>
    </div>
  );
};

export default AccountActivation;
